import axios from 'axios';

const ABOUT_URL = `${process.env.REACT_APP_BASE_URL}/v2/about`;

// Public endpoint: no auth required, so we skip the shared Api client.
export const getAbout = async () => {
  const { data } = await axios.get(ABOUT_URL);
  return data;
};
